import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const GlobalStyles = () => {
  const theme = useTheme();

  return (
    <MuiGlobalStyles
      styles={{
        'body': {
          margin: 0,
          fontFamily: theme.typography.fontFamily,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
          transition: theme.transitions.create(['background-color', 'color'], {
            duration: theme.transitions.duration.standard,
          }),
        },
        '*': {
          boxSizing: 'border-box',
        },
        '#root': {
          minHeight: '100vh',
          backgroundColor: theme.palette.background.default,
          transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.standard,
          }),
        },
      }}
    />
  );
}; 